import { Component, EventEmitter, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../../material.module';

@Component({
    selector: 'app-delete-confirmation-dialog',
    standalone: true,
    imports: [CommonModule, MaterialModule],
    templateUrl: './delete-confirmation-dialog.component.html',
    styleUrls: ['./delete-confirmation-dialog.component.css']
})
export class DeleteConfirmationDialogComponent {
    readonly confirmRequested = new EventEmitter<void>();
    isDeleting = false;

    constructor(
        public dialogRef: MatDialogRef<DeleteConfirmationDialogComponent, boolean>,
        @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
    ) { }

    confirm(): void {
        if (this.isDeleting) return;
        this.confirmRequested.emit();
    }

    cancel(): void {
        if (this.isDeleting) return;
        this.dialogRef.close(false);
    }

    setDeleting(isDeleting: boolean): void {
        this.isDeleting = isDeleting;
        this.dialogRef.disableClose = isDeleting;
    }
}
